import React from 'react';
import * as AllIcons from '@ant-design/icons';

/**
 * Маппинг строковых названий иконок → React-компоненты из @ant-design/icons.
 * Включает только Outlined-иконки (~400 шт).
 */
const ICON_MAP: Record<string, React.ComponentType<{ style?: React.CSSProperties }>> = {};

Object.entries(AllIcons).forEach(([name, component]) => {
  // Фильтруем только Outlined и исключаем утилиты/хелперы
  if (
    name.endsWith('Outlined') &&
    typeof component === 'object' &&
    component !== null &&
    'render' in component
  ) {
    ICON_MAP[name] = component as React.ComponentType<{ style?: React.CSSProperties }>;
  }
});

/** Отсортированный список всех доступных Outlined-иконок */
export const ICON_NAMES = Object.keys(ICON_MAP).sort();

/**
 * Разрешить строковое название иконки в React-элемент.
 * Fallback: QuestionCircleOutlined.
 */
export function resolveIcon(
  name: string | undefined | null,
  style?: React.CSSProperties,
): React.ReactElement {
  if (!name) {
    return React.createElement(AllIcons.QuestionCircleOutlined, { style });
  }
  const IconComponent = ICON_MAP[name];
  if (!IconComponent) {
    return React.createElement(AllIcons.QuestionCircleOutlined, { style });
  }
  return React.createElement(IconComponent, { style });
}

export { ICON_MAP };
